<template>
    <div>
        <template v-if="proptyp == 'proptyptext'">
            <template v-for="prop in returnProp">
                <label :for="prop.PropertyId" class="d-flex customer-prop align-items-center" :class="{'active': prop.value == 1}">
                    <div>
                        <img :src="img" alt="propertyImage">
                    </div>
                    <div class="form-check flex-fill mb-0">
                        <input type="checkbox" value="" v-model="prop.value" :id="prop.PropertyId" class="form-check-input d-none" @change="customerPropCheck(prop)">
                        <div class="customerPropText" v-html="desc"></div>
                    </div>
                    <div class="check" :class="{'active': prop.value == 1}">
                        <i class="fa fa-check"></i>
                    </div>
                </label>
            </template>
        </template>
        <template v-else-if="proptyp == 'myAccount'">
            <template v-for="(prop,index) in returnProp">
                <div class="input-unit">
                    <input type="text" class="prop"  v-model="prop.value" maxlength="100" @blur="customerPropBlur(prop)">
                    <label for="prop">
                        {{ prop.Name }}
                    </label>
                </div>
            </template>
        </template>
        <template v-else-if="proptyp == 'checkout'">
            <template v-for="prop in returnProp" v-if="prop.defaultValue!=1">
                <label :for="prop.PropertyId" class="d-flex customer-prop align-items-center" :class="{'active': prop.value == 1}">
                    <div>
                        <img :src="img" alt="propertyImage">
                    </div>
                    <div class="form-check flex-fill mb-0">
                        <input type="checkbox" value="" v-model="prop.value" :id="prop.PropertyId" class="form-check-input d-none" @change="customerPropCheck(prop)">
                        <div class="customerPropText" v-html="desc"></div>
                    </div>
                    <div class="check" :class="{'active': prop.value == 1}">
                        <i class="fa fa-check"></i>
                    </div>
                </label>
            </template>
        </template>
    </div>
</template>

<script>
    export default
    {
        props: ['template','user','showprop','proptyp','addresstyp','address','desc','img'],
        data: function()
        {
            return {
                userProps:0,
                showall:true,
                numbertoshow:1,
                userAdressData:[]
            };
        },
        mounted: function()
        {
            let _self = this;
            _self.getcustomerdata();
        },
        methods:
            {

                getcustomerdata:function()
                {
                    let _self = this;
                    let addresstyp = this.addresstyp;

                    let userid   = this.user.id;
                    let language = App.language;
                    let showProp = this.showprop;
                    return $.ajax(
                        {
                            type: 'GET',
                            url: '/phywe/customerprops/'+ userid + '/' + App.language + '/',
                            dataType: 'json',
                            success: function (data)
                            {
                                let toReturn = [];
                                for(let i = 0; i < data.length; i++)
                                {
                                    if(showProp.indexOf(data[i].Property.propertyId) > -1)
                                    {
                                        for(let p = 0; p < data[i].Name.length; p++ )
                                        {
                                            if(data[i].Name[p].lang == language)
                                            {
                                                data[i].Name = data[i].Name[p].name;
                                            }
                                        }
                                        data[i].PropertyId = data[i].Property.propertyId;
                                        if(data[i].Property.hasOwnProperty('relationValues'))
                                        {
                                            for(let r = 0; r < data[i].Property.relationValues.length; r++ )
                                            {
                                                if(data[i].hasOwnProperty('value'))
                                                {
                                                    if( data[i].PropertyId == 12 || data[i].PropertyId == 13 )
                                                    {
                                                        data[i].value        = data[i].value + parseInt(data[i].Property.relationValues[r].value);
                                                        data[i].defaultValue = data[i].value + parseInt(data[i].Property.relationValues[r].value);
                                                    }
                                                    else
                                                    {
                                                        data[i].value        = data[i].value + data[i].Property.relationValues[r].value;
                                                        data[i].defaultValue = data[i].value + data[i].Property.relationValues[r].value;
                                                    }


                                                }
                                                else
                                                {
                                                    if(data[i].PropertyId == 12 || data[i].PropertyId == 13)
                                                    {
                                                        data[i].value        = parseInt(data[i].Property.relationValues[r].value);
                                                        data[i].defaultValue = parseInt(data[i].Property.relationValues[r].value);
                                                    }
                                                    else
                                                    {
                                                        data[i].value        = data[i].Property.relationValues[r].value;
                                                        data[i].defaultValue = data[i].Property.relationValues[r].value;
                                                    }
                                                }

                                            }
                                        }
                                        toReturn.push(data[i]);
                                    }

                                }
                                // Wenn noch keine CustomerProps hinterlegt wurden hole dir die Namen über eine andere Route und die entsprechden Property Ids
                                if(toReturn.length == 0)
                                {
                                    $.ajax(
                                        {
                                            type: 'POST',
                                            url: '/phywe/customerprops/getnames/'+ App.language + '/',
                                            data: {"propnames" : showProp },
                                            dataType: 'json',
                                            success: function (returnData)
                                            {
                                                for(let i = 0; i < returnData.length; i++)
                                                {
                                                    for(let p = 0; p < returnData[i].length; p++ )
                                                    {

                                                        if(returnData[i][p].lang == language)
                                                        {
                                                            toReturn.push(
                                                                {
                                                                    "Name": returnData[i][p].name,
                                                                    "Property":returnData[i][p],
                                                                    "PropertyId":returnData[i][p].propertyId,
                                                                    "value":0,
                                                                    "defaultValue":0
                                                                });
                                                        }
                                                    }

                                                }
                                                _self.userProps = toReturn;

                                            },
                                            error: function (jqXHR, textStatus, errorThrown)
                                            {
                                                console.error(errorThrown);
                                            }
                                        });
                                }
                                else
                                {
                                    _self.userProps = toReturn;
                                }
                            },
                            error: function (jqXHR, textStatus, errorThrown)
                            {
                                console.error(errorThrown);
                            }
                        });


                },
                countup: function ()
                {
                    this.numbertoshow = this.numbertoshow + 1;
                },
                countdown: function (obj,field)
                {

                 /*   console.log(obj[field]);*/
                    obj[field] = '';
                    this.numbertoshow = this.numbertoshow - 1;
                },
                customerPropCheck: function (prop)
                {
                    if(prop.value==true)
                    {
                        prop.value = 1;
                    }
                    else
                    {
                        prop.value = 0;
                    }
                    let data =
                        {
                            "propertyId"    : prop.PropertyId,
                            "customerId"    : ceresStore.state.user.userData.id,
                            "content"       : prop.value,
                            "lang"          : App.language
                        }
                    $.ajax(
                        {
                            type: 'POST',
                            url: '/phywe/customerprops/save/'+ App.language + '/',
                            data: data,
                            dataType: 'json',
                            success: function (response)
                            {
                                /*console.log(response);*/
                            },
                            error: function (jqXHR, textStatus, errorThrown)
                            {
                                console.error(errorThrown);
                            }
                        });
                },
                customerPropBlur: function (prop)
                {
                    let data =
                        {

                            "propertyId"    : prop.PropertyId,
                            "customerId"    : ceresStore.state.user.userData.id,
                            "content"       : prop.value,
                            "lang"          : App.language
                        }
                    $.ajax(
                        {
                            type: 'POST',
                            url: '/phywe/customerprops/save/',
                            data: data,
                            dataType: 'json',
                            success: function (response)
                            {
                             /*   console.log(response);*/
                            },
                            error: function (jqXHR, textStatus, errorThrown)
                            {
                                console.error(errorThrown);
                            }
                        });
                }
            },
        computed:
            {
                returnProp: function()
                {
                    let _self = this;
                    return _self.userProps;
                },
                customerAdress: function ()
                {
                    let _self = this;
                    return _self.userAdressData;
                }
            }
    }
</script>
